export default __webpack_public_path__ + "static/media/cuatro.33a00bbb.jpg";